import { render, staticRenderFns } from "./PublicRIDC.vue?vue&type=template&id=14d20620&scoped=true&"
import script from "./PublicRIDC.vue?vue&type=script&lang=ts&"
export * from "./PublicRIDC.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14d20620",
  null
  
)

export default component.exports